import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

interface Props {
  disabled: boolean
  onClick: () => void
}
const SendButton = ({ disabled, onClick }: Props) => {
  return (
    <Box padding={1} flexShrink={0}>
      <Button fullWidth variant="contained" color="primary" onClick={onClick} disabled={disabled}>
        OCRアップロード
      </Button>
    </Box>
  )
}

export default SendButton
